import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';
import { HowQrWorks } from '../../templates';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */

class WorkplaceChallengesView extends Component {

	render () {

		const {
			heading,
			cards,
			subHeading,
		} = this.props.content.qrLandingPage.howItWorks;

		return (

			<HowQrWorks
				cards={cards}
				heading={heading}
				subHeading={subHeading}
				className='HowQrWorksView'
			/>
		);
	}
}

export default withLanguageContext(WorkplaceChallengesView);



// WEBPACK FOOTER //
// ./src/components/views/HowQrWorksView/HowQrWorksView.js